import * as _ from "lodash";
import ProductTypesStore from "@shared/svelte/Stores/ProductTypesStore.js";
import { get } from "svelte/store";
import type { ProductTypesStoreType } from "@admin/svelte/types/ProductTypesStoreTypes";
import type { Product } from "@shared/types/ProductLine";

const NO_VINTAGE = "NV";
const MULTIPLE_VINTAGES = "MV";
const sortOrder = (a: string, b: string) => {
  a = a === NO_VINTAGE ? "1000" : a;
  b = b === NO_VINTAGE ? "1000" : b;
  a = a === MULTIPLE_VINTAGES ? "0000" : a;
  b = b === MULTIPLE_VINTAGES ? "0000" : b;

  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const buildVintagesList = (products: Product[]): string[] => {
  const vintages = _.uniq(
    _.compact(
      _.map(products, function (product) {
        if (product.vintage_year) {
          return String(product.vintage_year);
        }
      })
    )
  );
  vintages.sort(sortOrder).reverse();

  if (products.some(p => p.vintage_year === null) && products.some(p => p.vintage_year != null)) {
    vintages.unshift("Current");
  }

  return vintages;
};

export const hasVintage = (productTypeName: string, vintages: string[]): boolean => {
  if (vintages.length < 1) return false;

  const storeValue = get(ProductTypesStore) as unknown;
  const validTypes = (storeValue as ProductTypesStoreType).types.filter(t => t.has_vintage_year);
  const validTypeNames = validTypes.map(t => t.name);

  return validTypeNames.includes(productTypeName);
};
